import { render, staticRenderFns } from "./SelectMaterialModal.vue?vue&type=template&id=081e1ae2&scoped=true"
import script from "./SelectMaterialModal.vue?vue&type=script&lang=js"
export * from "./SelectMaterialModal.vue?vue&type=script&lang=js"
import style0 from "./SelectMaterialModal.vue?vue&type=style&index=0&id=081e1ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081e1ae2",
  null
  
)

export default component.exports